import React from 'react';

export function Demo4Dashboard() {
  return <></>;
}
